import { API } from "aws-amplify";
import { useEffect, useState } from "react";
import Loading from "../../_shared/components/Loading/Loading";
import { useUserSubscriptionsQuery } from "../../_shared/graphql";
import { CreditCard, creditCardSchema } from "../_shared/models/CreditCard";
import styles from "./ManageSubscriptions.module.scss";
import "./ManageSubscriptions.scss";
import AddonsSelection from "./components/AddonsSelection/AddonsSelection";
import ChangesPanel from "./components/ChangesPanel/ChangesPanel";
import PlanSelection from "./components/PlanSelection/PlanSelection";
import {
  SubscriptionsProvider,
  useSubscriptionsContext,
} from "./contexts/SubscriptionsContext";
import { TickersProvider } from "./contexts/TickersContext";

const ManageSubscriptions = () => {
  const { currentPlanIndex } = useSubscriptionsContext();

  // list of user's credit cards
  const [creditCardList, setCreditCardList] = useState<CreditCard[]>([]);

  const { billingDate, onCancel } = useSubscriptionsContext();
  const { loading } = useUserSubscriptionsQuery();

  const getCardList = async () => {
    const getListCards = await API.post("auth", "/cognito/listCards", {});
    // ensure the data we get back is what we expect
    const cardList: CreditCard[] = getListCards.map((card: any) => {
      const parsed = creditCardSchema.safeParse(card);
      if (parsed.success) {
        return parsed.data;
      } else {
        // fail silently but log error
        console.error(parsed.error);
        return card;
      }
    });
    setCreditCardList(cardList);
  };

  useEffect(() => {
    getCardList();
  }, []);

  if (loading || !billingDate) return <Loading />;
  return (
    <div className={styles.container}>
      <h2 className={styles.sectionTitle}>Plan</h2>
      <PlanSelection />
      <h2 className={styles.sectionTitle}>Addons</h2>
      <AddonsSelection />
      <h2 className={styles.sectionTitle}>Subscription Changes</h2>
      <ChangesPanel
        noCard={creditCardList.length === 0}
        getCardList={getCardList}
      />
      {currentPlanIndex > -1 ? (
        <>
          <h2 className={styles.sectionTitle}>Danger Zone</h2>
          <button onClick={onCancel} className={styles.cancelButton}>
            Cancel Plan
          </button>
        </>
      ) : null}
    </div>
  );
};

export default () => (
  <SubscriptionsProvider>
    {/* tickers context consumes subscriptions */}
    <TickersProvider>
      <ManageSubscriptions />
    </TickersProvider>
  </SubscriptionsProvider>
);
